import { render, staticRenderFns } from "./expArray.vue?vue&type=template&id=3852df81&scoped=true"
import script from "./expArray.vue?vue&type=script&lang=js"
export * from "./expArray.vue?vue&type=script&lang=js"
import style0 from "./expArray.vue?vue&type=style&index=0&id=3852df81&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852df81",
  null
  
)

export default component.exports